import { LoadingContainer, Tabs, Tab } from 'peach/components'
import { Switch, Route, Redirect, useParams, useRouteMatch } from 'peach/router'

import { Page } from 'core/components'
import { useLedgerDebugger } from 'core/types'

import FancyLedgerTable from './FancyLedgerTable'
import LedgerFilters from './LedgerFilters'
import LedgerTable from './LedgerTable'
import LoanRawLedger from './LoanRawLedger'

const Ledger = () => {
  const { path, url } = useRouteMatch()
  const { companyId, personId, loanId } = useParams()

  const {
    data: ledger,
    isLoading,
    error,
  } = useLedgerDebugger({
    companyId,
    personId,
    loanId,
  })

  const tabs = (
    <Tabs basePath={url}>
      <Tab exact to=''>
        Ledger
      </Tab>
      <Tab to='/fancy-table'>Fancy Table</Tab>
      <Tab to='/raw'>Raw</Tab>
    </Tabs>
  )

  return (
    <LoadingContainer error={error} loading={isLoading}>
      <LedgerFilters
        ledger={ledger}
        render={({ ledger }) => (
          <Page variant='full'>
            <Switch>
              <Route exact path={`${path}`}>
                <LedgerTable ledger={ledger} />
              </Route>

              <Route path={`${path}/fancy-table`}>
                <FancyLedgerTable ledger={ledger} />
              </Route>

              <Route path={`${path}/raw`}>
                <LoanRawLedger ledger={ledger} />
              </Route>

              <Redirect to={`${url}`} />
            </Switch>
          </Page>
        )}
        right={tabs}
      />
    </LoadingContainer>
  )
}

export default Ledger
